<table class="mtx-calendar-table" role="grid">
  <thead class="mtx-calendar-table-header"></thead>
  <tbody mtx-calendar-body
         (@slideCalendar.done)="_calendarStateDone()"
         [@slideCalendar]="_calendarState"
         [todayValue]="_todayYear"
         [rows]="_years"
         [numCols]="4"
         [activeCell]="_getActiveCell()"
         [allowDisabledSelection]="true"
         [selectedValue]="_selectedYear!"
         (selectedValueChange)="_yearSelected($event)"></tbody>
</table>
